import { useTranslation } from '@/lib/i18n/i18n.client';

import { Text } from '@/components/atoms/Text';

type Props = {
  bestFor: string;
};

export default function ProductCardBestFor({ bestFor }: Props) {
  const { texts } = useTranslation();

  return (
    <div className='p-3 mb-4 rounded-sm bg-brand-25 dark:bg-brand-975 h-[104px]'>
      <Text variant='label' classNames={{ wrapper: 'mb-1 font-serif' }}>
        {texts.product_cards.best_for}
      </Text>
      <Text
        color='gray-500'
        variant='body-m'
        classNames={{
          wrapper: 'dark:text-gray-dark-500 line-clamp-3',
        }}
      >
        {bestFor}
      </Text>
    </div>
  );
}
